import ThemeEnum from '@/enums/themeEnum';
import { isDevMode } from '@/utils/env';

/**
 * 系统性配置
 * */
export default class ModuleProjectSetting {
  // AES对称加密接密-密钥
  static APP_AES_KEY = 'LhCG1';
  // logo图片配置
  static APP_IMAGE = '';

  // 开启加载页面，这里配置的是开发环境没得，方便开发
  static APP_LODING = !isDevMode();

  //app 名称
  static APP_NAME = 'MX1';

  //USDT符号
  static APP_USDT_SYMBOL = '$ ';

  // 是否使用后台配置的语言
  static APP_USE_LANG_FROM_NET = true;

  //默认币种 ,比如日本jpy ，美国ustd
  static APP_DEFAULT_CURRENCY = ' MXN';

  //  股票默认货币符号
  static APP_DEFAULT_CURRENCY_SYMBOL = ' MXN';

  //第三方股票货币符号
  static APP_DEFAULT_SYMBOL = 'R$ ';
  //第三方股票币名称  印度是INR, 巴西是BRL
  static APP_STOCK_SYMBOL = 'RM';

  // 默认主题
  static APP_DEFAULT_THEME = ThemeEnum.light;

  //默认语言 en | ja | zh
  static APP_DEFAULT_LOCALE = 'es';

  //默认时间格式
  static APP_DEFAULT_TIME_STRING = 'DD-MM-YYYY HH:mm:ss';

  //默认日期
  static APP_DEFAULT_DATE_STRING = 'DD-MM';

  //年月日日期格式
  static APP_DATE_STRING = 'DD-MM-YYYY';

  // 是否开启utc 时间
  static APP_UTC_TIME = true;

  // 是否开启日本时间
  static APP_JP_TIME = false;

  // 是否开启logo
  static App_SHOW_LOGO = true;

  // 是否显示邮箱 登录注册
  static APP_IS_SHOW_EMAIL = true;

  // 墨西哥城时间
  static chartTimezone = 'America/Mexico_City';

  // 盈亏比保留小数
  static PROFITLOSSDECIMAL = 2;

  // 金额小数保留位数
  static amountLen = 2;

  // 是否显示多余的 0
  static showZero: boolean = true;

  // 是否多币种账户
  static isMultiCurrencyAccount = true;

  // 是否开启登录注册隐私协议
  static isOpenPrivacy = true;
}
